import * as Icons from '@mui/icons-material'
export type IconType = keyof typeof Icons
export default Icons
